export let lowImportanceMenuText = "OcAvS";
export default {lowImportanceMenuText};